import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import * as actions from "../common/actions";
import { Dispatch } from "react";
import USAMap from "../components/FusionCharts/BODUSAMap";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateUi: (
      uiField: string,
      value: KeyValue[] | boolean | string | KeyValue,
    ) => {
      dispatch(actions.updateUi(uiField, value));
    },
    updateFilter: (filterField: string, value: string | string[]) => {
      dispatch(actions.updateFilter(filterField, value));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(USAMap);
